module.exports = __webpack_public_path__ + "static/media/9_nature.f78a235b.jpg";